import { Switch, Route, BrowserRouter } from "react-router-dom";
import HomeComponent from "../01Components/01Home/HomeComponent";

export default function Routes() {
    return (
        <BrowserRouter>
            <Switch>
                <Route exact path='/'>
                    <HomeComponent />
                </Route>
            </Switch>
        </BrowserRouter>
    )
}